import { render, staticRenderFns } from "./bgSet.vue?vue&type=template&id=041d29d9&scoped=true&"
import script from "./bgSet.vue?vue&type=script&lang=js&"
export * from "./bgSet.vue?vue&type=script&lang=js&"
import style0 from "./bgSet.vue?vue&type=style&index=0&id=041d29d9&prod&scoped=true&lang=css&"
import style1 from "./bgSet.vue?vue&type=style&index=1&id=041d29d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041d29d9",
  null
  
)

export default component.exports